/* Dismiss page color tooltips before the cart takes over focus on touch devices. */
(() => {
  const dismissColorTooltip = () => {
    document.dispatchEvent(new CustomEvent('theme:tooltip:close', {
      detail: { hideTransition: false, immediate: true },
    }));
    // Clear both animation states, including an interrupted touch-hover transition.
    document.querySelectorAll('.tooltip-default').forEach((tooltip) => {
      tooltip.classList.remove('is-visible', 'is-hiding');
    });
  };

  ['theme:cart:add', 'theme:product:add', 'theme:cart-drawer:open', 'theme:cart-drawer:close']
    .forEach((eventName) => document.addEventListener(eventName, dismissColorTooltip));
})();
